import React, { useEffect, useState } from 'react';
import { Switch, Space, Spin, message } from 'antd';
import api from '@/services/api';

const settingKeys = {
  ShowTires: 'Tires',
  ShowGrossPrice: 'Gross Price',
  hideNotFoundProducts: 'Hide Not Found Products',
  ShowPlateOrder: 'Plate Order',
  ShowHaynesPro: 'Haynes-pro',
  RecommendParts: 'Recommend Parts'
};

const GeneralTab = () => {
  const [loading, setLoading] = useState(false); // for initial fetch
  const [switchStates, setSwitchStates] = useState({});
  const [loadingStates, setLoadingStates] = useState({}); // for per-switch loading

  const fetchSettings = async () => {
    setLoading(true);
    const query = Object.keys(settingKeys).join('&');

    try {
      const response = await api()({
        url: '/webshop/management/settings/multiple',
        method: 'GET',
        params: { query }
      });

      const settings = {};
      for (const item of response.data.data) {
        settings[item.Keyword] = item.Value === 'true';
      }

      setSwitchStates(settings);
    } catch (error) {
      console.error('Error fetching general settings:', error);
      message.error('Failed to load general settings');
    } finally {
      setLoading(false);
    }
  };

  const updateSetting = async (key, value) => {
    setLoadingStates(prev => ({ ...prev, [key]: true }));
    setSwitchStates(prev => ({ ...prev, [key]: value }));

    try {
      await api()({
        url: '/webshop/management/settings',
        method: 'POST',
        data: {
          data: { [key]: value ? 'true' : 'false' }
        }
      });
      message.success(`${settingKeys[key]} updated`);
    } catch (error) {
      console.error(`Failed to update ${key}:`, error);
      message.error(`Failed to update ${settingKeys[key]}`);
    } finally {
      setLoadingStates(prev => ({ ...prev, [key]: false }));
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  return (
    <Spin spinning={loading}>
      <Space direction="vertical" size="middle">
        {Object.entries(settingKeys).map(([key, label]) => (
          <div key={key}>
            <Spin spinning={!!loadingStates[key]} size="small">
              <Switch
                checked={!!switchStates[key]}
                onChange={checked => updateSetting(key, checked)}
              />{' '}
              {label}
            </Spin>
          </div>
        ))}
      </Space>
    </Spin>
  );
};

export default GeneralTab;
